module.exports = "/assets/57829bb3cd8262c69ec3fdd59da52077.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/TR.png
// module id = 2986
// module chunks = 0